import React, { createContext, useContext, FC, ReactNode, useMemo } from 'react';

import useIsRelif from 'hooks/useIsRelif';

interface IsRelifContextType {
  isRelif: boolean;
  isPlaner: boolean;
}

const IsRelifContext = createContext<IsRelifContextType | undefined>(undefined);

interface Props {
  children: ReactNode;
}

export const IsRelifProvider: FC<Props> = ({ children }) => {
  const { isRelif, isPlaner } = useIsRelif();
  const value = useMemo(() => ({ isRelif, isPlaner }), [isRelif, isPlaner]);

  return <IsRelifContext.Provider value={value}>{children}</IsRelifContext.Provider>;
};

export const useIsRelifContext = () => {
  const context = useContext(IsRelifContext);
  if (context === undefined) {
    throw new Error('useIsRelifContext must be used within a IsRelifProvider');
  }
  return context;
};
